var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminConsole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_858324",
    "data-name": "Path 858324",
    d: "M44,4A40,40,0,1,0,84,44,40.015,40.015,0,0,0,44,4ZM58.44,29.36a7.72,7.72,0,1,1-7.72,7.72A7.7,7.7,0,0,1,58.44,29.36Zm-24-6.32A9.44,9.44,0,1,1,25,32.48,9.457,9.457,0,0,1,34.44,23.04Zm0,36.52v15A32.027,32.027,0,0,1,13.88,54.72c4.2-4.48,14.68-6.76,20.56-6.76a40.689,40.689,0,0,1,7.6.88C35.48,52.32,34.44,56.92,34.44,59.56ZM44,76a27.4,27.4,0,0,1-3.16-.16V59.56c0-5.68,11.76-8.52,17.6-8.52,4.28,0,11.68,1.56,15.36,4.6A32.075,32.075,0,0,1,44,76Z",
    transform: "translate(0 0)",
    fill: "#356f92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858325",
    "data-name": "Path 858325",
    d: "M0,0H88V88H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminConsole);
export default __webpack_public_path__ + "static/media/AdminConsole.6bc79c90538e6401687b0a3090a60985.svg";
export { ForwardRef as ReactComponent };